import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layout/Header';
import SideBar from './Layout/SideBar';
import axios from 'axios';
import 'datatables.net-dt';
import { baseURL } from '../axios/common';

export default function Dashboard() {
  const [userCount, setUserCount] = useState(0);
  const [activityCount, setActivityCount] = useState(0);

  useEffect(() => {
    axios.get(`${baseURL}admin/dashboard`)
      .then(response => {
        if (response.data.status) {
          setUserCount(response.data.data.user_count);
          setActivityCount(response.data.data.activity_count);
        }
      })
      .catch(error => {
        console.error('Error fetching dashboard data:', error);
      });
  }, []);

  return (
    <>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Dashboard</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Dashboard</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <div className="small-box">
                    <Link to="/">
                      <div className="inner">
                        <div className="icon1">
                          <i className="fa-solid fa-chart-column" />
                        </div>
                        <h3>{userCount}</h3>
                        <p>Total Users</p>
                      </div>
                      <div className="icon">
                        <i className="ion ion-bag" />
                      </div>
                    </Link>
                    <Link to={'/user'} className="small-box-footer">
                      More info <i className="fas fa-arrow-circle-right" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="small-box">
                    <Link to="/">
                      <div className="inner">
                        <div className="icon1">
                          <i className="fa-solid fa-cube" />
                        </div>
                        <h3>{activityCount}</h3>
                        <p>Total Activity</p>
                      </div>
                      <div className="icon">
                        <i className="ion ion-bag" />
                      </div>
                    </Link>
                    <Link to={'/activity'} className="small-box-footer">
                      More info <i className="fas fa-arrow-circle-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
